import { render, staticRenderFns } from "./ClientPlanSelect.vue?vue&type=template&id=b50e2fc4"
import script from "./ClientPlanSelect.vue?vue&type=script&lang=js"
export * from "./ClientPlanSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports